/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import dialogLogo from 'assets/images/dialogLogo.svg';
import CN from 'classnames';
import { Button } from 'components/atoms';
import { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LeftNav from '../SideBar/LeftNav';

export interface MenuDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  menuItemList: any[];
  firstRoute?: string;
  userDetails?: any;
  setIsMenuDrawerOpen?: any;
}

const MenuDrawer: FC<MenuDrawerProps> = ({
  isOpen,
  onClose,
  menuItemList,
  firstRoute,
  userDetails,
  setIsMenuDrawerOpen = undefined,
}) => {
  const navigate = useNavigate();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen((prev) => !prev);
  };

  const handleSignOut = () => {
    localStorage.clear();
    navigate('/auth/login', { replace: true });
  };

  const handleProfilePage = () => {
    console.log('Navigating to profile page...');
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const drawerClasses = CN(
    'fixed top-0 left-0 h-full bg-white shadow-lg transform transition-transform duration-300 z-50 w-72',
    {
      'translate-x-0': isOpen,
      '-translate-x-full': !isOpen,
    },
  );

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-10 z-40" onClick={onClose} />}

      {/* Drawer */}
      <div className={drawerClasses}>
        <div className="flex flex-col items-center w-full h-full px-6 pt-4 relative">
          {/* Dialog Logo */}
          <img src={dialogLogo} alt="dialog-logo" className="w-[80%]" />

          {/* Content Creator Badge */}
          {/* <div className="flex flex-row justify-center items-center w-full text-base text-white font-semibold bg-[#F7941E] rounded-lg px-4 py-3 mt-6">
            <i className="ri-pie-chart-2-fill pr-2 text-[20px] font-normal" />
            Content Creator
          </div> */}

          {/* Left Nav Links */}
          <LeftNav
            menuItemList={menuItemList}
            firstRoute={firstRoute || ''}
            userDetails={userDetails}
            setIsMenuDrawerOpen={setIsMenuDrawerOpen}
          />
        </div>
      </div>
    </>
  );
};

export default MenuDrawer;
